module.exports = __webpack_public_path__ + "fonts/iconfont.9c3be50.ttf";